module.exports = __webpack_public_path__ + "static/media/bird.abeedbba.svg";